import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AddressValidationService } from '@core/services/address-validation/address-validation.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { QueryAddressGeocodeGQL } from 'app/main/locations/services/location.service';
import { Subject } from 'rxjs';
import { debounceTime, map, takeUntil } from 'rxjs/operators';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var AddressComponent = /** @class */ (function () {
    function AddressComponent(addressGeocodeGQL, addressValidationService, fuseTranslationLoaderService) {
        this.addressGeocodeGQL = addressGeocodeGQL;
        this.addressValidationService = addressValidationService;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.editableValue = true;
        this.inputValue = new FormControl([Validators.required]);
        this.loading = false;
        this.addresses = [];
        this.removeSubscriptions = new Subject();
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    AddressComponent.prototype.ngOnInit = function () {
        var _this = this;
        var address = this.addressForm.value;
        if (!address.formattedAddress) {
            this.deselectAddress();
        }
        else {
            this.selectedAddress = address.formattedAddress;
            this.inputValue.setValue(address);
            this.inputValue.setErrors(null);
        }
        this.inputValue.valueChanges
            .pipe(takeUntil(this.removeSubscriptions), debounceTime(1000)).subscribe(function (value) {
            var e_1, _a;
            _this.addresses = [];
            if (!_this.selectedAddress && _this.validation) {
                try {
                    for (var _b = tslib_1.__values(Object.keys(_this.validation)), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var key = _c.value;
                        delete _this.validation[key];
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            if (value && typeof value === 'string') {
                _this.searchAddressGeocode(value);
            }
        });
        this.addressForm.get('formattedAddress').valueChanges.subscribe(function (value) {
            _this.selectedAddress = value;
        });
        this.addressForm.valueChanges.subscribe(function () {
            _this.validation = _this.addressValidationService.validateAddress(_this.addressForm.value);
        });
    };
    AddressComponent.prototype.ngOnDestroy = function () {
        this.removeSubscriptions.next();
        this.removeSubscriptions.complete();
    };
    AddressComponent.prototype.setSelectedAddress = function () {
        if (this.inputValue && this.inputValue.value) {
            var address = this.getAddressToSave(this.inputValue.value);
            this.selectedAddress = address.formattedAddress;
            this.addressForm.get('coords').setValue({
                latitude: address.coords.latitude,
                longitude: address.coords.longitude
            });
            this.validation = this.addressValidationService.validateAddress(address);
            if (this.validation && this.validation.errors && this.validation.errors.length) {
                this.addressForm.setErrors({
                    invalid: true
                });
                return;
            }
            this.addressForm.patchValue(address);
        }
    };
    AddressComponent.prototype.getAddressToSave = function (address) {
        return {
            postalCode: address.postalCode && address.postalCode.replace(/[^a-zA-Z0-9]/g, ''),
            city: address.city,
            state: address.state,
            streetName: address.streetName,
            number: address.number,
            neighborhood: address.neighborhood,
            formattedAddress: address.formattedAddress,
            complement: address.complement,
            coords: {
                latitude: address.coords.latitude,
                longitude: address.coords.longitude
            }
        };
    };
    AddressComponent.prototype.deselectAddress = function () {
        this.inputValue.setValue(this.selectedAddress);
        this.selectedAddress = null;
    };
    AddressComponent.prototype.searchAddressGeocode = function (formattedAddress) {
        var _this = this;
        this.loading = true;
        var input = {
            formattedAddress: formattedAddress,
            language: navigator.language || 'pt-BR'
        };
        this.addressGeocodeGQL
            .fetch({ input: input })
            .pipe(map(function (_a) {
            var data = _a.data;
            return data.addressGeocode;
        }))
            .subscribe(function (addressGeocode) {
            _this.addresses = addressGeocode;
            _this.loading = false;
        });
    };
    return AddressComponent;
}());
export { AddressComponent };
